import type { User } from '../../../../../../user';

export const getAccountUserPicProps = ({ avatarId, avatarUrl }: Pick<User, 'avatarId' | 'avatarUrl'>) => ({
    avatarId,
    lodpiUrl: avatarUrl,
    hidpiUrl: avatarUrl,
});
